import {
  Document,
  Page,
  Text,
  View,
} from "@react-pdf/renderer";
import dayjs from "dayjs";
import React from "react";

import { formatIndianCurrency, getMonthInStringNotOneIndexBased } from "../../../utils/common";
import { logger } from "../../../utils/logger";
import ReportHeader1 from "../report-header1";
import { fonts, reportStyles } from "../report-style";
fonts();
function SalaryReportPdf({
  salaryReportPDFData,
  allowances,
  salaryReportSummary,
  organizationInfo,
  orgDetails
  // salaryReportPDFData
}) {
  logger.log(salaryReportPDFData, "999999")
  const hasNonZeroOTAmount = salaryReportPDFData.some(employee => employee.ot_amount !== 0);
  const hasNonZeroIncentive = salaryReportPDFData.some(employee => employee.incentive_amount !== 0);
  const hasNonZeroBonus = salaryReportPDFData.some(employee => employee.bonus_amount !== 0);
  const hasNonZeroOtherAmt = salaryReportPDFData.some(employee => employee.any_other_amt !== 0);
  const hasNonZeroAdvanceAmt = salaryReportPDFData.some(employee => employee?.advance_amount !== 0);
  const hasNonZeroCanteenAmt = salaryReportPDFData.some(employee => employee?.canteen !== 0);
  const hasNonZeroTdsAmt = salaryReportPDFData.some(employee => employee?.tds !== 0);
  const hasNonZeroLoanAmt = salaryReportPDFData.some(employee => employee?.loan_advance !== 0);
  const hasNonZeroLabourLawAmt = salaryReportPDFData.some(employee => employee?.labour_welfare !== 0);
  const hasNonZeroAnyOtherDeductionAmt = salaryReportPDFData.some(employee => employee?.any_other_deduction !== 0);
  
  return (
    <>
      <Document>
        <Page size="A4" orientation="landscape" style={reportStyles.page}
        >
          <View fixed>
            <ReportHeader1 organization_info={organizationInfo} />
          </View>
          <Text style={reportStyles.pdfHeaderTableHeading}>
            Salary Report of {getMonthInStringNotOneIndexBased(salaryReportPDFData[0]?.month)} {salaryReportPDFData[0]?.year} (Form - B)
          </Text>
          <View style={reportStyles.pdfHeaderTable}>
            <View style={reportStyles.pdfHeaderBox}>
              <Text>Total Employee:</Text>
              <Text>{salaryReportSummary?.total_employee ? salaryReportSummary?.total_employee : '0'}</Text>
            </View>

            <View style={reportStyles.pdfHeaderBox}>
              <Text>Salaried Employee:</Text>
              <Text>{salaryReportSummary?.total_salaried_employees ? salaryReportSummary?.total_salaried_employees : '0'}</Text>©
            </View>

            <View style={reportStyles.pdfHeaderBox}>
              <Text>Wages Employee:</Text>
              <Text>{salaryReportSummary?.total_wages_employees ? salaryReportSummary?.total_wages_employees : '0'}</Text>
            </View>

            <View style={reportStyles.pdfHeaderBox}>
              <Text>New Joining:</Text>
              <Text>{salaryReportSummary?.total_new_employees ? salaryReportSummary?.total_new_employees : '0'}</Text>
            </View>

            <View style={reportStyles.pdfHeaderBox}>
              <Text>Left In Service:</Text>
              <Text>{salaryReportSummary?.total_left_employees ? salaryReportSummary?.total_left_employees : '0'}</Text>
            </View>

            <View style={reportStyles.pdfHeaderBox}>
              <Text>Total Employees Absent for Entire Month:</Text>
              <Text>{salaryReportSummary?.total_on_leave_employee ? salaryReportSummary?.total_on_leave_employee : '0'}</Text>
            </View>

            <View style={reportStyles.pdfHeaderBox}>
              <Text>EPF Member:</Text>
              <Text>{salaryReportSummary?.total_epf_member ? salaryReportSummary?.total_epf_member : '0'}</Text>
            </View>

            <View style={reportStyles.pdfHeaderBox}>
              <Text>ESI Member:</Text>
              <Text>{salaryReportSummary?.total_esi_member ? salaryReportSummary?.total_esi_member : '0'}</Text>
            </View>

            <View style={reportStyles.pdfHeaderBox}>
              <Text>Employee Under P-Tax :</Text>
              <Text>{salaryReportSummary?.total_ptax_under_employee ? salaryReportSummary?.total_ptax_under_employee : '0'}</Text>
            </View>


            <View style={reportStyles.pdfHeaderBox}>
              <Text>Total Gross Wages:</Text>
              <Text>₹{salaryReportSummary?.total_gross_wages ? salaryReportSummary?.total_gross_wages.toFixed(2) : '0'}</Text>
            </View>
            <View style={reportStyles.pdfHeaderBox}>
              <Text>ESI Covered Wages:</Text>
              <Text>₹{salaryReportSummary?.total_esi_covered_wages ? salaryReportSummary?.total_esi_covered_wages.toFixed(2) : '0'}</Text>
            </View>
            <View style={reportStyles.pdfHeaderBox}>
              <Text>ESI Not Covered Wages:</Text>
              <Text>₹{salaryReportSummary?.total_not_esi_covered_wages ? salaryReportSummary?.total_not_esi_covered_wages.toFixed(2) : '0'}</Text>
            </View>

            <View style={reportStyles.pdfHeaderBox}>
              <Text>EPF Cover Wages:</Text>
              <Text>₹{salaryReportSummary?.total_epf_cover_gross_wages ? salaryReportSummary?.total_epf_cover_gross_wages.toFixed(2) : '0'}</Text>
            </View>
            <View style={reportStyles.pdfHeaderBox}>
              <Text>EPF Not Cover Wages:</Text>
              <Text>₹{salaryReportSummary?.total_epf_not_cover_gross_wages ? salaryReportSummary?.total_epf_not_cover_gross_wages.toFixed(2) : '0'}</Text>
            </View>

            <View style={reportStyles.pdfHeaderBox}>
              <Text>EPF Contribution:</Text>
              <Text>₹{salaryReportSummary?.total_epf_contribution ? salaryReportSummary?.total_epf_contribution.toFixed(2) : '0'}</Text>
            </View>

            <View style={reportStyles.pdfHeaderBox}>
              <Text>ESI Contribution:</Text>
              <Text>₹{salaryReportSummary?.total_esi_contribution ? salaryReportSummary?.total_esi_contribution.toFixed(2) : '0'}</Text>
            </View>

            <View style={reportStyles.pdfHeaderBox}>
              <Text>P-Tax Amount:</Text>
              <Text>₹{salaryReportSummary?.total_ptax_amount ? salaryReportSummary?.total_ptax_amount.toFixed(2) : '0'}</Text>
            </View>

            <View style={reportStyles.pdfHeaderBox}>
              <Text>Advance Amount:</Text>
              <Text>₹{salaryReportSummary?.total_advance_amount ? salaryReportSummary?.total_advance_amount.toFixed(2) : '0'}</Text>
            </View>

            <View style={reportStyles.pdfHeaderBox}>
              <Text>Net Pay:</Text>
              <Text>₹{salaryReportSummary?.total_net_amount_payable_after_deduction ? salaryReportSummary?.total_net_amount_payable_after_deduction.toFixed(2) : '0'}</Text>
            </View>
          </View>

          <View style={reportStyles.ReportTable}>
            <View style={reportStyles.ReportTh} fixed>
              <Text
                style={[
                  reportStyles.ReportHeaderCell,
                  { width: "2%", borderRight: "1px solid #ccc" },
                ]}
              >
                SL NO
              </Text>
              <Text
                style={[
                  reportStyles.ReportHeaderCell,
                  { width: "5%", borderRight: "1px solid #ccc" },
                ]}
              >
                E-CODE
              </Text>
              <Text
                style={[
                  reportStyles.ReportHeaderCell,
                  { width: "12%", borderRight: "1px solid #ccc" },
                ]}
              >
                NAME
              </Text>
              {/* <Text
                style={[
                  reportStyles.ReportHeaderCell,
                  { width: "4%", textAlign:"center",  borderRight: "1px solid #ccc" },
                ]}
              >
                Salary Type
              </Text> */}
              <Text
                style={[
                  reportStyles.ReportHeaderCell,
                  { width: "8%", textAlign: "center", borderRight: "1px solid #ccc" },
                ]}
              >
                UAN
              </Text>
              {/* <Text
                style={[
                  reportStyles.ReportHeaderCell,
                  { width: "4%", textAlign: "center", borderRight: "1px solid #ccc" },
                ]}
              >
                PRESENT DAYS
              </Text> */}
              <Text
                style={[
                  reportStyles.ReportHeaderCell,
                  { width: "4%", textAlign: "center", borderRight: "1px solid #ccc" },
                ]}
              >
                MONTH DAYS
              </Text>
              <Text
                style={[
                  reportStyles.ReportHeaderCell,
                  { width: "5%", textAlign: "center", borderRight: "1px solid #ccc" },
                ]}
              >
                PAYABLE DAYS
              </Text>
              <Text
                style={[
                  reportStyles.ReportHeaderCell,
                  { width: "4%", textAlign: "center", borderRight: "1px solid #ccc" },
                ]}
              >
                NCP DAYS
              </Text>

              {hasNonZeroOTAmount &&
                <Text
                  style={[
                    reportStyles.ReportHeaderCell,
                    { width: "3%", textAlign:"right", borderRight: "1px solid #ccc" },
                  ]}
                >
                  OT HR
                </Text>
              }

              <Text
                style={[
                  reportStyles.ReportHeaderCell,
                  { width: "5%", textAlign: "right", borderRight: "1px solid #ccc" },
                ]}
              >
                BASIC
              </Text>
 
                {allowances.map((item, index) => (
                  <>
                    <Text
                      style={[
                        reportStyles.ReportHeaderCell,
                        {  width: "5%", textAlign:"right", borderRight: "1px solid #ccc" },
                      ]}
                      key={index}
                    >
                      {item.toUpperCase()}
                    </Text>
                  </>
                ))}
                {hasNonZeroOTAmount &&
                  <Text
                    style={[
                      reportStyles.ReportHeaderCell,
                      { width: "5%", textAlign:"right", borderRight: "1px solid #ccc" },
                    ]}
                  >
                    OT AMT
                  </Text>
                }

                <Text
                  style={[
                    reportStyles.ReportHeaderCell,
                    { width: "5%", textAlign: "right", borderRight: "1px solid #ccc" },
                  ]}
                >
                  Gross
                </Text>

                {hasNonZeroIncentive &&
                  <Text
                    style={[
                      reportStyles.ReportHeaderCell,
                      {  width: "5%",borderRight: "1px solid #ccc" },
                    ]}
                  >
                    INCENTIVES
                  </Text>
                }
                {hasNonZeroBonus &&
                  <Text
                    style={[
                      reportStyles.ReportHeaderCell,
                      {  width: "5%", textAlign:"right", borderRight: "1px solid #ccc" },
                    ]}ReportHeaderCell
                  >
                    BONUS
                  </Text>
                }
                {hasNonZeroOtherAmt &&
                  <Text style={[reportStyles.ReportHeaderCell,{ width: "5%", textAlign:"right", borderRight: "1px solid #ccc" }]}>OTHER</Text>
                }

              <Text
                style={[
                  reportStyles.ReportHeaderCell,
                  { width: "5%", textAlign: "right", borderRight: "1px solid #ccc" },
                ]}
              >
                TOTAL EARNING
              </Text>

              <Text
                style={[
                  reportStyles.ReportHeaderCell,
                  { width: "5%", textAlign: "right", borderRight: "1px solid #ccc" },
                ]}
              >
                EE EPF
              </Text>
              <Text
                style={[
                  reportStyles.ReportHeaderCell,
                  { width: "5%", textAlign: "right", borderRight: "1px solid #ccc" },
                ]}
              >
                EE ESI
              </Text>
              <Text
                style={[
                  reportStyles.ReportHeaderCell,
                  { width: "5%", textAlign: "right", borderRight: "1px solid #ccc" },
                ]}
              >
                P-TAX
              </Text>
              {hasNonZeroCanteenAmt &&
                <Text style={[reportStyles.ReportHeaderCell, { width: "5%", textAlign: "right", borderRight: "1px solid #ccc" }]}>
                  CANTEEN
                </Text>
              }
              {hasNonZeroTdsAmt &&
                <Text style={[reportStyles.ReportHeaderCell, { width: "5%", textAlign: "right", borderRight: "1px solid #ccc" }]}>
                  TDS
                </Text>
              }
              {hasNonZeroAdvanceAmt &&
                <Text
                  style={[
                    reportStyles.ReportHeaderCell,
                    { width: "5%", textAlign: "right", borderRight: "1px solid #ccc" },
                  ]}
                >
                  ADV REPAYMENT
                </Text>
              }
              {hasNonZeroLoanAmt &&
                <Text
                  style={[
                    reportStyles.ReportHeaderCell,
                    { width: "5%", textAlign: "right", borderRight: "1px solid #ccc" },
                  ]}
                >
                  LOAN RECOVERY AMT
                </Text>
              }
              
              {hasNonZeroLabourLawAmt &&
                <Text style={[reportStyles.ReportHeaderCell, { width: "5%", textAlign: "right", borderRight: "1px solid #ccc" }]}>
                  LWF
                </Text>
              }
              {hasNonZeroAnyOtherDeductionAmt &&
                <Text style={[reportStyles.ReportHeaderCell, { width: "5%", textAlign: "right", borderRight: "1px solid #ccc" }]}>
                  Other Deductio
                </Text>
              }

                
              <Text
                style={[
                  reportStyles.ReportHeaderCell,
                  { width: "5%", textAlign: "right", borderRight: "1px solid #ccc" },
                ]}
              >
                TOTAL DEDUCT
              </Text>

              <Text
                style={[
                  reportStyles.ReportHeaderCell,
                  { width: "5%", textAlign: "right", borderRight: "1px solid #ccc" },
                ]}
              >
                NET PAY
              </Text>
              <Text style={[reportStyles.ReportHeaderCell, { width: "4%" }]}>
                REMARKS
              </Text>
            </View>
            {salaryReportPDFData.map((item, index) => {
              const totalDeductionAmount = item?.total_deduction ?
               
              formatIndianCurrency(Number(item?.total_deduction).toFixed())
                  //  +
                  // Number(item?.advance_amount) +
                  // Number(item?.canteen) +
                  // Number(item?.epf_arrear) +
                  // Number(item?.any_other_deduction) +
                  // Number(item?.tds) + 
                  // Number(item?.loan_advance)
                
                : '--';
              const totalEarningAmount = (
                formatIndianCurrency(Number(item?.gross_salary).toFixed())
                // + Number(item?.bonus_amount) +
                //   Number(item?.incentive_amount) +
                //   Number(item?.gross_arrear) +
                //   Number(item?.any_other_amt)
                
              )
              return (
                <>
                  <View style={[reportStyles.ReportTd,{break: false}]} wrap={false}>
                    <View
                      style={[
                        reportStyles.ReportTdCell,
                        { width: "2%", borderRight: "1px solid #ccc" },
                      ]}
                    >
                      <Text>{index + 1}</Text>
                    </View>
                    <View
                      style={[
                        reportStyles.ReportTdCell,
                        { width: "5%", borderRight: "1px solid #ccc" },
                      ]}
                    >
                      <Text>{item?.employee_code ? item?.employee_code : '--'}</Text>
                    </View>

                    <View
                      style={[
                        reportStyles.ReportTdCell,
                        { width: "12%", borderRight: "1px solid #ccc" },
                      ]}
                    >
                      <Text>{item?.employee_name ? item?.employee_name : '--'}</Text>
                    </View>

                    {/* <View
                      style={[
                        reportStyles.ReportTdCell,
                        { width: "12%", borderRight: "1px solid #ccc" },
                      ]}
                    >
                      <Text>{item?.employees?.department ? item?.employees?.department : '--'}</Text>
                    </View>

                    

                    <View
                      style={[
                        reportStyles.ReportTdCell,
                        { width: "4%",textAlign:"center",  borderRight: "1px solid #ccc" },
                      ]}
                    >
                      <Text>{item?.employees?.employment_type === "full_time" ? 'Parmanent' :
                        item?.employees?.employment_type === "probationary" ? 'Provision Period' :
                          item?.employees?.employment_type === "contractual" ? 'Contractual' :
                            item?.employees?.employment_type === "part_time" ? 'Part Time' : '--'}
                      </Text>
                    </View>

                    <View
                      style={[
                        reportStyles.ReportTdCell,
                        {
                          maxWidth: "5%",
                          width: "5%",
                          textAlign:"center", 
                          borderRight: "1px solid #ccc",
                        },
                      ]}
                    >
                      <Text>{item?.employees?.salary_type ? item?.employees?.salary_type : '--'}</Text>
                    </View> */}



                    <View
                      style={[
                        reportStyles.ReportTdCell,
                        { width: "8%", textAlign: "center", borderRight: "1px solid #ccc" },
                      ]}
                    >
                      <Text>{item?.employees?.uan_no ? item?.employees?.uan_no : '--'}</Text>
                    </View>
                    {/* <View
                      style={[
                        reportStyles.ReportTdCell,
                        { width: "4%", textAlign: "center", borderRight: "1px solid #ccc" },
                      ]}
                    >
                      <Text>{item?.attendance?.present_days ? item?.attendance?.present_days : 0}</Text>
                    </View> */}
                    <View
                      style={[
                        reportStyles.ReportTdCell,
                        { width: "4%", textAlign: "center", borderRight: "1px solid #ccc" },
                      ]}
                    >
                      {item?.employees?.salary_type==="wages"?
                      <Text>{orgDetails?.wages_days ? orgDetails?.wages_days : 0}</Text>
                      :
                      <Text>{item?.attendance?.month_days ? item?.attendance?.month_days : 0}</Text>
                      }
                    </View>
                    <View
                      style={[
                        reportStyles.ReportTdCell,
                        { width: "5%", textAlign: "center", borderRight: "1px solid #ccc" },
                      ]}
                    >
                      <Text>{item?.payable_days ? item?.payable_days : '0'}</Text>
                    </View>
                    <View
                      style={[
                        reportStyles.ReportTdCell,
                        { width: "4%", textAlign: "center", borderRight: "1px solid #ccc" },
                      ]}
                    >
                      <Text>{item?.payable_days ? item?.ncp_days : '0'}</Text>
                    </View>
                    {hasNonZeroOTAmount &&
                      <View
                      style={[
                        reportStyles.ReportTdCell,
                        { width: "3%", textAlign: "right", borderRight: "1px solid #ccc" },
                      ]}
                      >
                      <Text>
                        {/* {item?.ot_hour ? formatIndianCurrency(item?.ot_hour) : '0'} */}
                        {item?.ot_hour ? `${Number((item.ot_hour / 60).toFixed(2))} hr` : '0.0 hr'}
                      </Text>
                      </View>
                    }
                      <View
                        style={[
                          reportStyles.ReportTdCell,
                          { width: "5%", textAlign:"right", borderRight: "1px solid #ccc" },
                        ]}
                      >
                        <Text>{item?.payable_basic_salary ? formatIndianCurrency(Math.round(Number(item?.payable_basic_salary))) : "00"}</Text>
                      </View>
                      {allowances.map((allowanceName, index) => {
                        const allowanceData = item?.allowance.find(a => a.allowance_name === allowanceName);
                        return (
                          <View
                            key={index}
                            style={[
                              reportStyles.ReportTdCell,
                              { width: "5%", textAlign:"right", borderRight: "1px solid #ccc" },
                            ]}
                          >
                            <Text>{allowanceData ? formatIndianCurrency(Math.round(Number(allowanceData.allowance_value)) ): "00"}</Text>
                          </View>
                        )
                      })}
                      {hasNonZeroOTAmount &&

                      <View
                        style={[
                          reportStyles.ReportTdCell,
                          { width: "5%", textAlign: "right", borderRight: "1px solid #ccc" },
                        ]}
                      >
                        <Text>{item?.ot_amount ? formatIndianCurrency(Math.round(Number(item?.ot_amount))) : "00"}</Text>
                      </View>}
                      <View
                      style={[
                        reportStyles.ReportTdCell,
                        { width: "5%", textAlign: "right", borderRight: "1px solid #ccc" },
                      ]}
                    >
                      <Text>
                        {formatIndianCurrency(totalEarningAmount)}
                      </Text>
                    </View>  
                    {hasNonZeroIncentive &&
                      <View
                        style={[
                          reportStyles.ReportTdCell,
                          { width: "5%", textAlign: "right", borderRight: "1px solid #ccc" },
                        ]}
                      >
                        <Text>{item?.incentive_amount ? formatIndianCurrency(Math.round(Number(item?.incentive_amount))) : "00"}</Text>
                      </View>}
                    {hasNonZeroBonus &&
                      <View
                        style={[
                          reportStyles.ReportTdCell,
                          { width: "5%", textAlign: "right", borderRight: "1px solid #ccc" },
                        ]}
                      >
                        <Text>{item?.bonus_amount ? formatIndianCurrency(Math.round(Number(item?.bonus_amount))) : "00"}</Text>
                      </View>}
                    {hasNonZeroOtherAmt &&
                      <View
                        style={[
                          reportStyles.ReportTdCell,
                          { width: "5%", textAlign: "right", borderRight: "1px solid #ccc" },
                        ]}
                      >
                        <Text>{item?.any_other_amt ? formatIndianCurrency(Math.round(Number(item?.any_other_amt))) : "00"}</Text>
                      </View>}


                    <View
                      style={[
                        reportStyles.ReportTdCell,
                        { width: "5%", textAlign: "right", borderRight: "1px solid #ccc" },
                      ]}
                    >
                      <Text>
                        {item?.earning_salary ? formatIndianCurrency(Math.round(Number(item?.earning_salary))) : "00"}
                      </Text>
                    </View>
                    <View
                      style={[
                        reportStyles.ReportTdCell,
                        { width: "5%", textAlign: "right", borderRight: "1px solid #ccc" },
                      ]}
                    >

                      <Text>{item?.epf_amount ? formatIndianCurrency(Math.round(Number(item?.epf_amount))) : "00"}</Text>
                    </View>
                    <View
                      style={[
                        reportStyles.ReportTdCell,
                        { width: "5%", textAlign: "right", borderRight: "1px solid #ccc" },
                      ]}
                    >
                      <Text>{item?.esi_amount ? formatIndianCurrency(Math.round(Number(item?.esi_amount))) : "00"}</Text>
                    </View>
                    <View
                      style={[
                        reportStyles.ReportTdCell,
                        { width: "5%", textAlign: "right", borderRight: "1px solid #ccc" },
                      ]}
                    >
                      <Text>{item?.pTaxAmount ? formatIndianCurrency(Math.round(Number(item?.pTaxAmount))) : "00"}</Text>
                    </View>
                    {hasNonZeroCanteenAmt &&
                      <View
                        style={[
                          reportStyles.ReportTdCell,
                          { width: "5%", textAlign: "right", borderRight: "1px solid #ccc" },
                        ]}
                      >
                        <Text>{item?.canteen ? formatIndianCurrency(Math.round(Number(item?.canteen)))  : "00"}</Text>
                      </View>}
                    {hasNonZeroTdsAmt &&
                    <View
                      style={[
                        reportStyles.ReportTdCell,
                        { width: "5%", textAlign: "right", borderRight: "1px solid #ccc" },
                      ]}
                    >
                      <Text>{item?.tds ? formatIndianCurrency(Math.round(Number(item?.tds))) : "00"}</Text>
                    </View>}
                    {hasNonZeroAdvanceAmt &&
                      <View
                        style={[
                          reportStyles.ReportTdCell,
                          { width: "5%", textAlign: "right", borderRight: "1px solid #ccc" },
                        ]}
                      >
                        <Text>{item?.advance_amount ? formatIndianCurrency(Math.round(Number(item?.advance_amount))) : '0'}</Text>
                      </View>}
                    {hasNonZeroLoanAmt &&
                      <View
                        style={[
                          reportStyles.ReportTdCell,
                          { width: "5%", textAlign: "right", borderRight: "1px solid #ccc" },
                        ]}
                      >
                        <Text>{item?.loan_advance ? formatIndianCurrency(Math.round(Number(item?.loan_advance))) : '0'}</Text>
                      </View>}
                    
                    {hasNonZeroLabourLawAmt &&
                      <View
                        style={[
                          reportStyles.ReportTdCell,
                          { width: "5%", textAlign: "right", borderRight: "1px solid #ccc" },
                        ]}
                      >
                        <Text>{item?.labour_welfare ? formatIndianCurrency(Math.round(Number(item?.labour_welfare))) : '0'}</Text>
                      </View>}

                      {hasNonZeroAnyOtherDeductionAmt &&
                      <View
                        style={[
                          reportStyles.ReportTdCell,
                          { width: "5%", textAlign: "right", borderRight: "1px solid #ccc" },
                        ]}
                      >
                        <Text>{item?.any_other_deduction ? formatIndianCurrency(Math.round(Number(item?.any_other_deduction))) : '0'}</Text>
                      </View>}  

                    <View
                      style={[
                        reportStyles.ReportTdCell,
                        { width: "5%", textAlign: "right", borderRight: "1px solid #ccc" },
                      ]}
                    >
                      <Text>
                        {item?.total_deduction ? formatIndianCurrency(totalDeductionAmount) : '0'}
                      </Text>
                    </View>
                    <View
                      style={[
                        reportStyles.ReportTdCell,
                        { width: "5%", textAlign: "right", borderRight: "1px solid #ccc" },
                      ]}
                    >
                      <Text>
                        {/* {formatIndianCurrency((Math.round(totalEarningAmount - totalDeductionAmount)))} */}
                        {item?.payable_salary ? formatIndianCurrency(Math.round(Number(item?.payable_salary))) : "00"}
                      </Text>
                    </View>
                    <View style={[reportStyles.ReportTdCell, { width: "4%" }]}>
                      <Text>
                        {(() => {
                          const joinDate = item?.employees?.join_date ? new Date(item.employees.join_date) : null;
                          const exitDate = item?.employees?.exit_formalities?.[0]?.exit_date ? new Date(item.employees.exit_formalities[0].exit_date) : null;
                          const recordMonth = item?.month;
                          const recordYear = item?.year;

                          if (joinDate && joinDate.getMonth() + 1 === recordMonth && joinDate.getFullYear() === recordYear) {
                            return `The Employee joined on ${joinDate.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}`;
                          }
                          if (exitDate && exitDate.getMonth() + 1 === recordMonth && exitDate.getFullYear() === recordYear) {
                            return `The Employee exited on ${exitDate.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}`;
                          }
                          return item?.remarks || "--";
                        })()}
                      </Text>
                    </View>
                  </View>
                </>
              )
            })}
          </View>
          {/* <Text style={reportStyles.pageNumber} render={({ pageNumber, totalPages }) => (
            `${pageNumber} / ${totalPages}`
          )} fixed />
          <Text style={reportStyles.downloadTime} fixed>
            Download Time & date: {dayjs().format("DD-MM-YYYY hh:mm A")}
          </Text> */}
          <View style={reportStyles.footer} fixed>
            <Text  >Download Time & date: {dayjs().format("DD-MM-YYYY hh:mm A")} </Text>
            <Text  render={({ pageNumber, totalPages }) => (
              `${pageNumber} / ${totalPages}`
            )}  />
          </View>
        </Page>
      </Document>
    </>
  )
};
export default SalaryReportPdf;
